module.exports = __webpack_public_path__ + "static/img/award4.196f396.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/index/award4.png
// module id = JMEP
// module chunks = 7